import { TRANSLATE_SET_LOCALE } from '../actions/translate';
import en_US from '~/translate/en_US';

const locale = process.env.REACT_APP_LOCALE;

const translations = {
    en_US
};

const translator = (locale, section, str) => {
    const strings = translations[locale] || {};

    if (!strings[section] || !strings[section][str]) {
        return str;
    }

    return strings[section][str];
};

const defaultState = {
    locale,
    translate: (...args) => translator(
        locale,
        ...args
    )
};

export default (state = defaultState, { type, payload }) => {
    if (type === TRANSLATE_SET_LOCALE) {
        return {
            locale: payload,
            translate: (...args) => translator(
                payload,
                ...args
            )
        }
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/reducers/translate.js